


$(window).on('scroll', function(){

    if( $(window).scrollTop()>=107 ){
        $('.site-header').addClass('fixed');
    }else{
        $('.site-header').removeClass('fixed');
    }

});

// $('.site-header').click(function(){
//     var current = $(window).scrollTop();
//     $(window).scrollTop(current+1);
//     console.log(current+1);
// });